export const ICON_TYPE = Symbol("__iconType__");
export const ICON_PRESET_SIZES = ["inherit", "mini", "small", "medium", "large"];
export const ICON_PRESET_COLORS = [
    "inherit",
    "default",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
];
